import $ from 'jquery';
window.$ = window.jQuery = $;

import 'foundation-sites';
import { attachAddressValidation } from './address-validation';
import { attachAdminAddressValidation } from "./address-validation-admin";
import { attachAddressModalHandlers} from "./address-modal";
import { initImportRecords } from "./import-records";
import { attachStatusInfo, attachBadgeTooltips } from "./status-info";
import { initAdminCharts } from "./admin-charts";
import { initPhoneInputs } from "./phone-input";
import { initPasswordPolicy } from "./password-policy";
import { initClaimReviewModal } from "./claim-review-modal";
import { initUnsavedChangesWarning } from "./unsaved-changes-warning";

/**
 * Attach submit-spinner behaviour to all forms that don't opt out.
 * - Forms with data-no-spinner="true" are skipped entirely.
 * - Forms with data-confirm="..." show a confirm dialog before submitting.
 * - Handles both button[type="submit"] and input[type="submit"].
 */
export function initFormSpinners() {
  document.querySelectorAll('form:not([data-no-spinner="true"])').forEach(form => {
    form.addEventListener('submit', function(e) {
      const confirmMsg = form.dataset.confirm;
      if (confirmMsg && !form.dataset.confirmed) {
        e.preventDefault();
        if (window.confirm(confirmMsg)) {
          form.dataset.confirmed = 'true';
          form.requestSubmit();
        }
        return;
      }
      delete form.dataset.confirmed;

      const btn = form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      // NOTE: we intentionally do not preserve/restore the original button
      // text or value here. Every current caller of initFormSpinners() is a
      // full-page POST/redirect flow, so the button is abandoned (page
      // navigates away or reloads) once the spinner shows — there's no
      // client-side path that re-enables the form. If this utility is ever
      // reused for a SPA-style form that can fail/cancel without a page
      // navigation, add a restore step (store the original text/value before
      // overwriting, and reset it alongside re-enabling the button).
      if (btn.tagName === 'BUTTON') {
        // textContent replaces all children, so set the text before
        // checking/appending the spinner icon.
        btn.textContent = 'Submitting...';
        if (!btn.querySelector('.fa-spinner')) {
          const spinner = document.createElement('i');
          spinner.className = 'fa-solid fa-spinner fa-spin';
          spinner.style.marginLeft = '0.4rem';
          btn.appendChild(spinner);
        }
      } else {
        // input[type="submit"] — text lives in the value attribute, spinner
        // is appended as a sibling element.
        btn.value = 'Submitting...';
        if (!btn.nextElementSibling || !btn.nextElementSibling.classList.contains('fa-spinner')) {
          const spinner = document.createElement('i');
          spinner.className = 'fa-solid fa-spinner fa-spin';
          spinner.style.marginLeft = '0.4rem';
          btn.insertAdjacentElement('afterend', spinner);
        }
      }
    });
  });
}

/**
 * Attach click-spinner behaviour to anchor tags with data-link-spinner.
 * Disables further clicks and appends a spinner icon on click.
 */
export function initLinkSpinners() {
  document.querySelectorAll('a[data-link-spinner]').forEach(link => {
    link.addEventListener('click', function() {
      if (link.dataset.spinning) return;
      link.dataset.spinning = 'true';
      const spinner = document.createElement('i');
      spinner.className = 'fa-solid fa-spinner fa-spin';
      spinner.style.marginLeft = '0.4rem';
      link.appendChild(spinner);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  /* address validation — registration form and dashboard address form */
  attachAddressValidation();
  attachAddressValidation('dashboard-address-form');
  attachAdminAddressValidation();
  attachAddressModalHandlers();

  // other features
  initImportRecords();
  attachStatusInfo();
  attachBadgeTooltips();
  initAdminCharts();
  initPhoneInputs();
  initFormSpinners();
  initLinkSpinners();
  initClaimReviewModal();
  initUnsavedChangesWarning();

  // Password policy feedback — reset-password page
  initPasswordPolicy(
    document.getElementById('reset-new-password'),
    document.getElementById('reset-password-policy')
  );

  // Password policy feedback — dashboard change-password section
  initPasswordPolicy(
    document.getElementById('dashboard-new-password'),
    document.getElementById('dashboard-password-policy')
  );

  // Password policy feedback — admin Edit User change-password card
  initPasswordPolicy(
    document.getElementById('admin-new-password'),
    document.getElementById('admin-password-policy')
  );
});
